import React from "react";
import { Controller } from "react-hook-form";

const Step4TeakSwans = ({
    control,
    watch,
    formData,
    goToPreviousStep,
    isLoading,
    updateLoading,
    step,
    isEditMode
}) => {
    // Determine displayed CBM
    const displayCbm =
        Number(formData?.modifyTotalCBM) > Number(formData?.totalCbm)
            ? formData?.modifyTotalCBM
            : formData?.totalCbm || formData?.totalTeakCbm || "";

    const shipToAddress = [
        formData?.toNumber,
        formData?.toStreet,
        formData?.toLandmark,
        formData?.toCity,
        formData?.toDistrict,
        formData?.toPincode,
    ]
        .filter(Boolean)
        .join(", ");

    const labelStyle = {
        fontSize: "11px",
        fontWeight: "600",
        letterSpacing: "0.5px",
        color: "#1F2937",
        width: "125px",
        flexShrink: 0,
        marginBottom: 0,
    };

    return (
        <div className="card shadow-sm border rounded-top-0 rounded-bottom-3 p-3 p-md-4 d-flex flex-column justify-content-between flex-grow-1">
            <div>
                {/* ── Section Heading ── */}
                <h2 className="text-center fw-bold text-uppercase fs-6 py-2 mb-4 border-bottom border-top gtss-text-primary">
                    Account Details
                </h2>

                {/* ── Row 1: PKL / Party/Agent / Lorry ── */}
                <div className="row g-3 mb-3">
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-pkl" style={labelStyle}>PKL :</label>
                        <div className="flex-grow-1">
                            <input id="ad-pkl" type="text" className="form-control bg-light" value={formData?.pkl ?? ""} readOnly />
                        </div>
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-partyAgent" style={labelStyle}>Party / Agent :</label>
                        <div className="flex-grow-1">
                            <input id="ad-partyAgent" type="text" className="form-control bg-light" value={`${formData?.partyName || ""} / ${formData?.agentName || ""}`} readOnly />
                        </div>
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-lorry" style={labelStyle}>Lorry :</label>
                        <div className="flex-grow-1">
                            <input id="ad-lorry" type="text" className="form-control bg-light" value={formData?.lorry ?? ""} readOnly />
                        </div>
                    </div>
                </div>

                {/* ── Row 2: Ship To (Full Width) ── */}
                <div className="row g-3 mb-3">
                    <div className="col-12 d-flex align-items-center">
                        <label htmlFor="ad-shipTo" style={labelStyle}>Ship To :</label>
                        <div className="flex-grow-1">
                            <input id="ad-shipTo" type="text" className="form-control bg-light" value={shipToAddress} readOnly />
                        </div>
                    </div>
                </div>

                {/* ── Row 3: CBM / Rate / AMT ── */}
                <div className="row g-3 mb-3">
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-cbm" style={labelStyle}>CBM :</label>
                        <div className="flex-grow-1">
                            <input id="ad-cbm" type="text" className="form-control bg-light" value={displayCbm ?? ""} readOnly />
                        </div>
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-rate" style={labelStyle}>Rate :</label>
                        <div className="flex-grow-1">
                            <input id="ad-rate" type="text" className="form-control bg-light" value={formData?.rate ?? ""} readOnly />
                        </div>
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-amount" style={labelStyle}>AMT :</label>
                        <div className="flex-grow-1">
                            <Controller control={control} name="amount"
                                render={({ field }) => (
                                    <input {...field} id="ad-amount" type="number" step="any" readOnly className="form-control bg-light" />
                                )}
                            />
                        </div>
                    </div>
                </div>

                {/* ── Row 4: MTS / EMPTY / MTS Amount ── */}
                <div className="row g-3 mb-3">
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-mts" style={labelStyle}>MTS :</label>
                        <div className="flex-grow-1">
                            <Controller control={control} name="mts"
                                render={({ field }) => (
                                    <input {...field} id="ad-mts" type="number" step="any" readOnly className="form-control bg-light" />
                                )}
                            />
                        </div>
                    </div>
                    <div className="col-12 col-md-4">
                        {/* Blank alignment spacing */}
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-sumMTS" style={labelStyle}>MTS Amount :</label>
                        <div className="flex-grow-1">
                            <Controller control={control} name="sumMTS"
                                render={({ field }) => (
                                    <input {...field} id="ad-sumMTS" type="number" step="any" readOnly className="form-control bg-light" />
                                )}
                            />
                        </div>
                    </div>
                </div>

                {/* ── Row 5: Discount ── */}
                <div className="row g-3 mb-3">
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-discount" style={labelStyle}>Discount :</label>
                        <div className="flex-grow-1">
                            <input id="ad-discount" type="text" className="form-control bg-light" value={formData?.load ?? ""} readOnly />
                        </div>
                    </div>
                </div>

                {/* ── Row 6: INV CBM / INV Rate / INV Amount ── */}
                <div className="row g-3 mb-3">
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-invCBM" style={labelStyle}>INV CBM :</label>
                        <div className="flex-grow-1">
                            <Controller control={control} name="invCBM"
                                render={({ field }) => (
                                    <input {...field} id="ad-invCBM" type="number" step="any" readOnly className="form-control bg-light" />
                                )}
                            />
                        </div>
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-invRate" style={labelStyle}>INV Rate :</label>
                        <div className="flex-grow-1">
                            <Controller control={control} name="invRate"
                                render={({ field }) => (
                                    <input {...field} id="ad-invRate" type="number" step="any" readOnly className="form-control bg-light" />
                                )}
                            />
                        </div>
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-invAmount" style={labelStyle}>INV Amount :</label>
                        <div className="flex-grow-1">
                            <Controller control={control} name="invAmount"
                                render={({ field }) => (
                                    <input {...field} id="ad-invAmount" type="number" step="any" readOnly className="form-control bg-light" />
                                )}
                            />
                        </div>
                    </div>
                </div>

                {/* ── Row 7: AVG CFT / NOS / Plus GST ── */}
                <div className="row g-3 mb-3">
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-avgCft" style={labelStyle}>AVG CFT :</label>
                        <div className="flex-grow-1">
                            <input id="ad-avgCft" type="text" className="form-control bg-light" value={formData?.avgCft ?? ""} readOnly />
                        </div>
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-nos" style={labelStyle}>NOS :</label>
                        <div className="flex-grow-1">
                            <input id="ad-nos" type="text" className="form-control bg-light" value={formData?.totalNos > 1 ? formData?.totalNos : (formData?.totalTeakNos ?? "")} readOnly />
                        </div>
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-plusGst" style={labelStyle}>Plus GST :</label>
                        <div className="flex-grow-1 d-flex align-items-center gap-2">
                            <Controller control={control} name="plusGst"
                                render={({ field }) => (
                                    <input
                                        id="ad-plusGst"
                                        type="checkbox"
                                        className="form-check-input"
                                        style={{ width: "20px", height: "20px", cursor: "pointer" }}
                                        checked={!!field.value}
                                        onChange={(e) => field.onChange(e.target.checked)}
                                    />
                                )}
                            />
                            <span className="small text-muted">{watch("plusGst") ? "Yes" : "No"}</span>
                        </div>
                    </div>
                </div>

                {/* ── Row 8: Distance / Party PIN-CODE / Ship TO PIN-CODE ── */}
                <div className="row g-3 mb-4">
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-distance" style={labelStyle}>Distance :</label>
                        <div className="flex-grow-1">
                            <input id="ad-distance" type="text" className="form-control bg-light" value={formData?.distance ?? ""} readOnly />
                        </div>
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-partyPincode" style={labelStyle}>Party PIN-CODE :</label>
                        <div className="flex-grow-1">
                            <input id="ad-partyPincode" type="text" className="form-control bg-light" value={formData?.fromPincode ?? ""} readOnly />
                        </div>
                    </div>
                    <div className="col-12 col-md-4 d-flex align-items-center">
                        <label htmlFor="ad-shipToPincode" style={labelStyle}>Ship TO PIN-CODE :</label>
                        <div className="flex-grow-1">
                            <input id="ad-shipToPincode" type="text" className="form-control bg-light" value={formData?.toPincode ?? ""} readOnly />
                        </div>
                    </div>
                </div>
            </div>

            {/* ── Navigation Buttons ── */}
            <div className="text-center pt-2 pb-1 d-flex flex-wrap justify-content-center gap-2 gap-sm-3">
                {step > 1 && (
                    <button
                        type="button"
                        id="pl-step4-back-btn"
                        className="btn btn-light px-5 py-2 fw-semibold border"
                        style={{ borderRadius: "20px" }}
                        onClick={goToPreviousStep}
                    >
                        Back
                    </button>
                )}
                {step === 4 && (
                    <button
                        type="submit"
                        id="pl-step4-submit-btn"
                        className="btn px-5 py-2 fw-semibold text-white gtss-bg-accent border-0"
                        style={{ borderRadius: "20px" }}
                        disabled={isLoading || updateLoading}
                    >
                        {isLoading || updateLoading ? "Saving..." : isEditMode ? "Update" : "Submit"}
                    </button>
                )}
            </div>
        </div>
    );
};

export default Step4TeakSwans;
